import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Platform,
} from "react-native";

import AppTheme from "../../AppTheme";
import ImageComponent from "../../common/ImageComponent";
import GroupIcons from "../../common/icons/groups";
import {
  getGroupImageTag,
  hasItems,
  isBaseCoreElement,
} from "../../../../helpers/utils";
import CollapseIcon from "../../common/icons/CollapseIcon";

const TreeHeaderItem = ({
  item,
  hasChildren = false,
  isCollapsed = false,
  level = 0,
  onPress = () => {},
}) => {
  const [numberOfLines] = useState(2);

  // Name
  let itemName = item.name;
  const isBaseGroup = level == 1 && isBaseCoreElement(itemName);
  const ImageTag = isBaseGroup ? getGroupImageTag(itemName) : ImageComponent;

  return (
    <View style={[styles.item, { paddingLeft: (level - 1) * 25 || 8 }]}>
      <TouchableOpacity
        onPress={onPress}
        style={[
          styles.media,
          hasChildren && !isBaseGroup ? styles.parentContainer : { flex: 2 },
        ]}
      >
        <View style={styles.logoContainer}>
          <ImageTag
            icon={item.icon}
            color={isBaseGroup ? AppTheme.almostBlack : AppTheme.containerWhite}
            style={[styles.logo, isBaseGroup && styles.baseLogo]}
          />
        </View>
        <Text
          numberOfLines={numberOfLines}
          title={itemName}
          style={styles.itemName}
        >
          {itemName}
        </Text>

        {hasItems(item.children) ? (
          <CollapseIcon isCollapsed={isCollapsed} onPress={onPress} />
        ) : null}
      </TouchableOpacity>
    </View>
  );
};

export default TreeHeaderItem;

const styles = StyleSheet.create({
  item: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    height: 40,
  },
  media: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  itemName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
    textTransform: "capitalize",
  },
  parentContainer: {
    backgroundColor: "#F3F2F1",
    borderColor: "#F4F6FA",
    borderWidth: 1,
    borderRadius: 100,
    height: 37,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 4,
    marginLeft: 0,
    flexShrink: 1,
  },
  tagText: {
    color: "#41A9CE",

    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  logoContainer: {
    marginRight: 6,
    position: "relative",
    width: 30,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: 20,
    height: 20,
  },
  baseLogo: {
    height: 32,
    marginLeft: -10,
  },
  gemLogo: {
    width: 20,
    height: 20,
  },
});
